export const toggleClassName = (
	className: string,
	component?: HTMLElement | null
) => component?.classList.toggle(className)
